import { z } from "zod";

export const leadFormSchema = z.object({
  fullName: z.string().trim().min(2, "Informe seu nome completo").max(120),
  phone: z.string().trim().min(10, "Telefone inválido").max(20),
  email: z.string().trim().email("E-mail inválido").max(255),
  regionGoiania: z.enum(["Sim", "Não"], { errorMap: () => ({ message: "Selecione" }) }),
  clientType: z.enum(["Sou construtor(a)", "Não sou construtor(a)"], { errorMap: () => ({ message: "Selecione" }) }),
  constructionStage: z.enum(["Inicial", "Parte Cinza", "Acabamento"], { errorMap: () => ({ message: "Selecione" }) }),
  deadline: z.enum(["Imediato", "Daqui 1 mês", "Daqui 2 meses", "Daqui a mais de 3 meses"], { errorMap: () => ({ message: "Selecione" }) }),
  quantity: z.enum(["1 a 5", "6 a 10", "11 a 20", "21 a 50", "51 a 100", "Mais de 100"], { errorMap: () => ({ message: "Selecione" }) }),
  message: z.string().trim().max(1000).optional(),
});

export type LeadFormValues = z.infer<typeof leadFormSchema>;

export const REGION_OPTIONS = ["Sim", "Não"] as const;
export const CLIENT_TYPE_OPTIONS = ["Sou construtor(a)", "Não sou construtor(a)"] as const;
export const STAGE_OPTIONS = ["Inicial", "Parte Cinza", "Acabamento"] as const;
export const DEADLINE_OPTIONS = ["Imediato", "Daqui 1 mês", "Daqui 2 meses", "Daqui a mais de 3 meses"] as const;
export const QUANTITY_OPTIONS = ["1 a 5", "6 a 10", "11 a 20", "21 a 50", "51 a 100", "Mais de 100"] as const;

export const LOST_REASON_OPTIONS = [
  "Valor",
  "Modelo",
  "Frete",
  "Outro produtos",
  "Outras localidades",
  "Outros",
] as const;

export const PURCHASE_CATEGORY_OPTIONS = [
  "Indicação",
  "Tráfego",
  "Orgânico",
  "Outros",
] as const;

export const LEAD_SOURCE_OPTIONS = [
  "Tráfego",
  "GMN",
  "Site",
  "Orgânico",
  "Indicação",
  "Loja física",
  "Outros",
] as const;

export const LEAD_STATUSES = [
  "Não Abordado",
  "Abordado",
  "Follow-Up",
  "Agendado",
  "Orçamento",
  "Proposta Enviada",
  "Não Respondeu",
  "Convertido",
  "Recompra",
  "Desqualificado",
  "Perdido",
] as const;
export type LeadStatus = typeof LEAD_STATUSES[number];

export type Purchase = {
  purchaseId: string;
  leadId: string;
  customerKey?: string;
  fullName?: string;
  phone?: string;
  email?: string;
  purchaseDate: string;
  purchaseMonth?: string;
  purchaseDoors: number;
  purchaseValue: number;
  purchaseSource?: string;
  purchaseCategory?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type BusinessMetrics = {
  totalLeads: number;
  qualifiedLeads: number;
  totalRevenue: number;
  totalDoors: number;
  purchaseCount: number;
  convertedCustomerCount: number;
  repurchaseCount: number;
  repeatCustomerCount: number;
  avgLtv: number;
  avgPurchasesPerCustomer: number;
  avgRepurchasePerCustomer: number;
  repurchaseRate: number;
  averageTicket: number;
  avgDoorsPerPurchase: number;
};
